import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import LearnMoreModalListItem from '../base/LearnMoreModalListItem';
import LearnMoreModal from '../base/LearnMoreModal';
import { ACADEMY_LANDING_PAGE_LESSON_URL, KNOWLEDGE_BASE_LANDING_PAGES_ARTICLE_URL } from '../../../utils/urls';
import { useModalTracker } from '../../../hooks/tracking';
import KnowledgeBaseButton from '../../button/KnowledgeBaseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreateLandingPageModal = props => {
  const {
    onClose
  } = props;
  const {
    trackLink
  } = useModalTracker('CreateLandingPageModal');
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    closeButton: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.backToSetup"
    }),
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.landingPages.heading"
    }),
    illustrationName: "marketing-templates",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.landingPages.body"
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.landingPages.choose"
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.landingPages.customize"
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.landingPages.add"
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "300",
      children: /*#__PURE__*/_jsx(KnowledgeBaseButton, {
        onClick: () => trackLink('landing page article'),
        url: KNOWLEDGE_BASE_LANDING_PAGES_ARTICLE_URL,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.modal.landingPages.learnMoreRead"
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "300",
      children: /*#__PURE__*/_jsx(Link, {
        external: true,
        href: ACADEMY_LANDING_PAGE_LESSON_URL,
        onClick: () => trackLink('landing page lesson'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.modal.landingPages.learnMoreWatch"
        })
      })
    })]
  });
};
export default CreateLandingPageModal;